<div class="rollover-header">
  <div class="rollover-header__brand-logo">
    <img
      class="rollover__image"
      [src]="content.logo.src"
      [alt]="content.logo.alt"
    />
  </div>
  <div class="rollover-header__title" [innerHTML]="content.title"></div>
  <div class="rollover-header__subtitle" [innerHTML]="content.subtitle"></div>
  <div class="rollover-header__divider"></div>
  <div
    class="rollover-header__description"
    [innerHTML]="content.description"
  ></div>
</div>
